export { default } from './ErrorBlock';
